import React, { useState, useEffect, useContext } from "react";
import {
  User,
  Phone,
  Mail,
  MapPin,
  Shield,
  Clock,
  Hospital,
} from "lucide-react";
import Navbar from "../components/Navbar";
import languageContext from "../context/language/languageContext";
import axios from "axios";

const DoctorProfile = () => {
  const {
    lang,
    setSessionTimeout,
    setAlert,
    setMessage,
  } = useContext(languageContext);

  const [doctor, setDoctor] = useState(null);

  const getDoctorDetails = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/show_profile",
        {},
        { headers: headersList }
      );

      if (response.status === 200) {
        setDoctor(response.data?.doctor_details || {});
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data.detail === "Token has expired"
      ) {
        setSessionTimeout(true);
      } else {
        console.error("Error Details:", error.message);
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };

  useEffect(() => {
    getDoctorDetails();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-tr from-blue-50 to-white">
      <Navbar />

      {/* Top margin after fixed Navbar */}
      <div className="pt-24 px-4 pb-12 max-w-4xl mx-auto">
        <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8 space-y-6 border border-blue-100">
          {!doctor ? (
            <p className="text-center text-gray-500 text-lg">
              Loading doctor details...
            </p>
          ) : (
            <>
              {/* Doctor Name */}
              <h2 className="text-3xl font-bold text-blue-800 flex items-center gap-3">
                <User className="w-6 h-6" />
                {doctor.doctor_name || (
                  <span className="text-gray-400">Not Provided</span>
                )}
              </h2>

              {/* Grid Info */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 text-sm">
                <p className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-blue-500" />
                  {doctor.doctor_email || (
                    <span className="text-gray-400">Not Provided</span>
                  )}
                </p>

                <p className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-green-500" />
                  {doctor.phone_no || (
                    <span className="text-gray-400">Not Provided</span>
                  )}
                </p>

                <p className="flex items-center gap-2">
                  <Hospital className="w-4 h-4 text-purple-500" />
                  {doctor.clinic_name || (
                    <span className="text-gray-400">Clinic not specified</span>
                  )}
                </p>

                <p className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-pink-500" />
                  {doctor.address || (
                    <span className="text-gray-400">No address</span>
                  )}
                </p>

                <p className="flex items-center gap-2">
                  <Shield className="w-4 h-4 text-yellow-500" />
                  <span>Registration No:</span>{" "}
                  {doctor.registration_no || "N/A"}
                </p>

                <p className="flex items-center gap-2">
                  <Shield className="w-4 h-4 text-red-400" />
                  <span>Medical License No:</span>{" "}
                  {doctor.medical_licence_no || "N/A"}
                </p>

                <p className="flex items-center gap-2">
                  🎓 <span>Degree:</span> {doctor.degree_name || "N/A"}
                </p>

                <p className="flex items-center gap-2">
                  <Clock className="w-4 h-4 text-indigo-500" />
                  <span>OPD Time:</span> {doctor.opd_time || "N/A"}
                </p>
              </div>

              {/* UPI QR Section */}
              {doctor.upi_scan_code && (
                <div className="mt-6 text-center">
                  <p className="font-semibold text-blue-700 mb-2">
                    Scan to Pay
                  </p>
                  <img
                    src={doctor.upi_scan_code}
                    alt="UPI Scan Code"
                    className="mx-auto w-40 h-40 rounded-xl border border-blue-200 shadow-sm"
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;
